import {
  type Configuration,
  PublicClientApplication,
} from '@azure/msal-browser'

const AZURE_TENANT_ID = import.meta.env.VITE_AZURE_TENANT_ID
const AZURE_CLIENT_ID = import.meta.env.VITE_AZURE_CLIENT_ID

const msalConfig: Configuration = {
  auth: {
    clientId: AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${AZURE_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
}

export const msalInstance = new PublicClientApplication(msalConfig)
